































import { Component, Vue } from 'vue-property-decorator';
import { User } from 'firebase';

import 'firebase/auth';
import * as firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';

@Component
export default class App extends Vue {
  private showMenu = false;

  private created(): void {
    // Initialize Firebase
    const config = {
      apiKey: 'AIzaSyDuNshEtUFNM7bZAl62aQWyp_EBgUZGvaQ',
      authDomain: 'radiotation-169318.firebaseapp.com',
      databaseURL: 'https://radiotation-169318.firebaseio.com',
      projectId: 'radiotation-169318',
      storageBucket: 'radiotation-169318.appspot.com',
      messagingSenderId: '990909845123',
    };
    firebase.initializeApp(config);

    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        firebase.auth().signInAnonymously().catch((error) => {
          if (error.code === 'auth/operation-not-allowed') {
            console.log('You must enable Anonymous auth in the Firebase Console.');
          } else {
            console.log(error);
          }
        });
        return;
      }

      this.$root.$data.firebaseUser = user;
      user.getIdToken().then((token: string) => {
        const req = {
          token,
          name: user.displayName,
          anonymous: user.isAnonymous,
        };
        this.$http.post('verifyToken', req).then(() => {
          this.fetchUser();
        });
      });
      /*
      const displayName = user.displayName;
      const email = user.email;
      const emailVerified = user.emailVerified;
      const photoURL = user.photoURL;
      const uid = user.uid;
      const phoneNumber = user.phoneNumber;
      const providerData = user.providerData;
      */
    }, (error) => {
      console.log(error);
    });
  }

  private handleError(data: any): void {
    console.log(data);
  }

  // Show the sign in button if we aren't logged in, or if we are logged in,
  // but anonymously.
  get showSignIn(): boolean {
    const user = this.$root.$data.firebaseUser;
    return !this.$root.$data.loggedIn || (user && user.isAnonymous);
  }

  private fetchUser(): void {
    this.$http.get('user').then((response) => {
      const data = response.data;
      if (!data.Error) {
        this.$root.$data.loggedIn = true;
      }
    });
  }

  private toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }
}
